import { defaultState } from './state';

export default {
  SET_CLEAR_STATE: (state) => {
    Object.assign(state, defaultState());
  },
  SET_PROVIDER_ID: (state, value) => { state.providerId = value; },
  SET_IS_SHOWN: (state, value) => { state.innerIsShown = value; },
  SET_TYPE: (state, value) => { state.type = value; },
  SET_LOADING: (state, value) => { state.loading = value; },
  SET_TABLE_OPTIONS: (state, value) => { state.tableOptions = value; },
  SET_ALL_NETWORKS: (state, value) => { state.allNetworks = value; },
  SET_PACKAGES: (state, value) => {
    state.packages = value.map((obj) => ({
      id: obj.id,
      name: obj.name,
      type: obj.type,
      fixedCost: obj.fixedCost,
      discountPercent: obj.discountPercent,
      sync: true,
    }));
  },
  SET_SELECTED_NETWORK_ID: (state, value) => { state.selectedNetworkId = value; },
  SET_SEARCH: (state, value) => { state.search = value; },
  SET_SELECTED_PACKAGE: (state, value) => { state.selectedPackages = value; },
  SET_MULTIPLIER: (state, value) => { state.multiplier = value; },
  SET_ERRORS_NOTIFY: (state, value) => { state.errorsNotify = value; },
  SET_ERRORS_MESSAGE: (state, value) => { state.errors = value; },
  SET_ERRORS: (state, value) => { state.errors = value; },
  SET_SAVE_BTN_LOADING: (state, value) => { state.saveBtnLoading = value; },
};
